interface Props {
  children: React.ReactNode
}

// Simple pass-through layout - parent handles sizing
export function SubLayout({ children }: Props) {
  return (
    <div className="w-full h-full">
      {children}
    </div>
  )
}
